import React, { useContext, useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { ModalContext } from 'App';
import Select from 'react-select';
import PropTypes from 'prop-types';
import _ from 'lodash';
import CreateModal from '../components/CreateModal';
import CalendarComponent from '../components/CalendarComponent';
import Information from '../components/Information';

import 'react-big-calendar/lib/css/react-big-calendar.css';

import * as actions from '../action';
import * as c from '../constant';

function AppointmentsContainer({
  appointmentList,
  getAppointmentsList,
  showAppointment,
  appointmentInfo,
  getSystemModuleList,
  systemModuleData,
}) {
  const setModal = useContext(ModalContext);
  const [transaction, setTransaction] = useState('');

  const setStatusFilter = e => {
    setTransaction(e);
    getAppointmentsList({
      system_module_id: e.value,
    });
  };

  const handleAddModal = data => e => {
    e.preventDefault();
    setModal({
      isOpen: true,
      content: <CreateModal statusOption={data} />,
      title: 'Add Appointment',
      modalSize: 'modal-md',
    });
  };

  useEffect(() => {
    getSystemModuleList();
    getAppointmentsList({
      order: 'ASC',
      system_module_id: '5',
    });
    setTransaction({
      label: 'Occupational Permit / Health Certificate',
      value: 5,
    });
    return () => {};
  }, []);

  const statusOption = _.map(systemModuleData, value => {
    return { label: value.attributes.description, value: value.id, name:value.attributes.name };
  });

  const onSelectEvent = data => {
    showAppointment(data.id);
  };

  /* eslint no-plusplus: ["error", { "allowForLoopAfterthoughts": true }] */
  const formatEvents = data => {
    const newArr = [];
    for (let i = 0; i < Object.keys(data).length; i++) {
      if (data[i]) {
        const attrib = data[i].attributes;
        newArr.push({
          id: data[i].id,
          transaction: attrib.system_module,
          available_slots: attrib.available_slot,
          period: attrib.period,
          quota: attrib.quota,
          start: attrib.appointment_date,
          end: attrib.appointment_date,
          title: attrib.system_module,
          consumed: attrib.consumed,
        });
      }
    }
    return newArr;
  };

  return (
    <div className="container-fluid card-section-content">
      <div className="row bg-white pr-2 py-2 mb-2">
        <div className="col-12 d-flex ">
          <span className="full-label">Appointments</span>
          <button
            type="button"
            onClick={handleAddModal(statusOption)}
            className="btn btn-primary cms-bg-color-primary cms-outline-primary  btn-round font-weight-bold px-4 ml-auto   "
          >
            Add&nbsp;
            <i className="fas fa-plus" />
          </button>
        </div>
      </div>

      <div className="w-100">
        <div className="row">
          <div className="col-md-8">
            <div className="card">
              <div className="row p2">
                <div className="col-md-12">
                  <div className="d-flex align-items-right my-2">
                    <div className="d-flex align-items-center">
                      <div>
                        <label className="form-label mt-2 mx-2 mb-0">
                          <span className="text-muted">
                            <h4>Transaction:</h4>
                          </span>
                        </label>
                      </div>
                      <Select
                        styles={{
                          container: base => ({
                            ...base,
                            width: 400,
                          }),
                          menu: base => ({
                            ...base,
                            zIndex: 900,
                          }),
                        }}
                        value={transaction}
                        onChange={setStatusFilter}
                        options={statusOption}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-md-12">
                  <div
                    style={{ height: 'calc(100vh - 193px)', minHeight: 600 }}
                  >
                    <CalendarComponent
                      data={
                        appointmentList.length !== 0
                          ? formatEvents(appointmentList)
                          : []
                      }
                      selected={appointmentInfo}
                      onSelectEvent={onSelectEvent}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="col-4">
            <Information data={appointmentInfo} />
          </div>
        </div>
      </div>
    </div>
  );
}

AppointmentsContainer.propTypes = {
  appointmentList: PropTypes.instanceOf(Object).isRequired,
  appointmentInfo: PropTypes.instanceOf(Object).isRequired,
  getAppointmentsList: PropTypes.instanceOf(Function).isRequired,
  showAppointment: PropTypes.instanceOf(Function).isRequired,
  getSystemModuleList: PropTypes.instanceOf(Function).isRequired,
  systemModuleData: PropTypes.instanceOf(Object).isRequired,
};

const mapStateToProps = ({ api }) => ({
  appointmentList: _.get(api, `${c.GET_APPOINTMENTS_LIST}.list`) || [],
  appointmentInfo: _.get(api, `${c.SHOW_APPOINTMENTS}.res.data`) || [],
  systemModuleData: _.get(api, `${c.GET_SYSTEM_MODULES}.res.data`) || [],
});

const enhance = _.flowRight([withRouter, connect(mapStateToProps, actions)]);

export default enhance(AppointmentsContainer);
